import { Provider } from "react-redux";
import ConfigLauncher from "../Launcher";
import { store } from "../store";

export default function App() {
  return (
    <Provider store={store}>
      <ConfigLauncher />
    </Provider>
  );
}
